import { StripeService } from './../../../../core/services/stripeService/stripe-service.service';
import { Component} from '@angular/core';
import { serverError } from './../../../../core/models/messages';
import { LocalStorageService } from './../../../../core/services/local-storage.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';
import Swal from 'sweetalert2';
import { FeatureService } from '@core/services/feature/features.service';
import { environment } from '@env/environment';
import { EsnConsultantService } from '@core/services/esn-consultant/esn-consultant.service';
import { IntervenantService } from '@core/services/intervenant/intervenant.service';

@Component({
  selector: 'app-change-offer',
  templateUrl: './change-offer.component.html',
  styleUrls: ['./change-offer.component.css'],
})
export class ChangeOfferComponent {
  paymentHandler: any = null;
  test: any;
  selectedOffer: any;
  listOffer: any;
  currentOffersList: any;
  totalItems: any;
  company_id: any;
  stateAbonnement: any;
  currentUser: any;
  companyRoleId: any;
  perMonth: boolean = true;
  perYears: boolean = false;
  listPermissions:any;
  active_subscription_plan_id :any;
  pending_plan_id :any;
  private unsubscribeAll: Subject<void> = new Subject();
  allFeatures: any[] = [];
  currentFeatureUsage: any = [];
  listIds: any = [];
  listconsultant: any = [];
  selectedConsultant: any = [];
  listintervenant: any = [];
  selectedIntervenant: any = [];
  urlimage: string = environment.baseUrlGalery;
  url: string = environment.baseUrl + '/api';
  lowerUsageFeatures: any[] = [];
  loading: boolean = false;

  TRIAL_PLAN_ID = 4
  constructor(
    private stripeService: StripeService,
    private esnConsultantService: EsnConsultantService,
    private intervenantService: IntervenantService,
    private featuresService: FeatureService,
    private localStorageService: LocalStorageService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    this.company_id = this.localStorageService.getData('clientConnected');
    //this.getListPermissions();
  // this.getFeatureUsage();
   this.getListFeatures();
    this.getListOffer();
    this.getcurrentUser();
    this.getActiveSubscriptionPlan();

  }
  getFeatureUsage() {
    this.featuresService.getFeatureUsage().subscribe({
      next: (res: any) => {
        this.currentFeatureUsage = res.data;
      },
      error: () => {
        this.toastr.error('Failed to retrieve active subscription usage');
      }
    });
  }
  getActiveSubscriptionPlan() {
    this.stripeService.getActiveSubscriptionPlan().subscribe({
      next: (res: any) => {
        if (res.status === 200) {
          if(res.data && res.data.plan_id) {
            this.active_subscription_plan_id = res.data.plan_id;
            this.pending_plan_id = res.data.pending_plan_id;
            this.getListConsultants();
            this.getListIntervenants();
          } else {
            this.active_subscription_plan_id = null;
            this.pending_plan_id = null
          }
        }
      },
      error: () => {
        this.toastr.error('Failed to retrieve active subscription plan');
      }
    });
  }
  getcurrentUser() {
    this.currentUser = this.localStorageService.getData('UserInfo');
    this.companyRoleId = JSON.parse(this.currentUser).role_user_id;
  }
  getListFeatures() {
    this.featuresService.getAllFeatures().subscribe({
      next: (res: any) => {
        this.allFeatures = res.data;
      },
      error: () => {
        this.toastr.error(serverError);
  }
    });
  }
  getListConsultants() {
    this.esnConsultantService.getAllConsultants().subscribe({
      next: (res: any) => {
        this.listconsultant = res.data;
      },
      error: () => {
        this.toastr.error(serverError);
  }
    });
  }
  getListIntervenants() {
    this.intervenantService.getAllIntervenants().subscribe({
      next: (res: any) => {
        this.listintervenant = res.data;
      },
      error: () => {
        this.toastr.error(serverError);
  }
    });
  }

  getListPermissions() {
    this.stripeService
      .getListPermissions()
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          if (res.status == 200) {
            this.listPermissions = res.data;

          }
        },
        error: () => {
          this.toastr.error(serverError);
        },
      });
  }
  /* get list offer */
  getListOffer() {
    this.spinner.show();
    this.stripeService
      .getListOffer()
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.spinner.hide();
          if (res.status === 200) {
            this.listOffer = res.data;
            this.filteredPermissionsPerOffer = this.listOffer.map((offer: any) => {
              let allExtendedPermissions: any[] = [];

              // Collect extended_permissions for the current offer
              if (offer.extended_permissions && offer.extended_permissions.length > 0) {
                allExtendedPermissions = offer.extended_permissions;
              }

              // Filter permissions that are not in the current offer's extended_permissions
              if (this.listPermissions && allExtendedPermissions.length > 0) {
                return this.listPermissions.filter((permission: any) =>
                  !allExtendedPermissions.some((p: any) => p.id === permission.id)
                );
              } else {
                // If no extended_permissions found, return all permissions
                return this.listPermissions;
              }
            });
          } else {
            console.error('Failed to retrieve offers');
          }
        },
        error: () => {
          this.spinner.hide();
          this.toastr.error(serverError);
        },
      });
  }

  // Variable to store filtered permissions for each offer
  filteredPermissionsPerOffer: any[] = [];





  changeOfferPerMonth() {
    this.perMonth = true;
    this.perYears = false;
  }
  changeOfferPerYears() {
    this.perYears = true;
    this.perMonth = false;
  }

  onSubmit(recent_offer: any) {
    this.selectedOffer = recent_offer;
    this.lowerUsageFeatures = [];
    this.selectedConsultant = [];
    this.selectedIntervenant = [];

    // Check if there's an active subscription to compare with
    if (this.active_subscription_plan_id && this.active_subscription_plan_id  !== this.TRIAL_PLAN_ID) {
        // Loop through each feature in recent_offer to compare with current usage
        for (const feature of recent_offer.features) {
            const currentUsage = this.currentFeatureUsage.find((f: any) => f.id === feature.id);

            if (currentUsage) {
                const maxUsage = feature.pivot?.metadata?.max_usage;
                const currentUsed = currentUsage.used;

                // Check if there’s a defined max_usage, not unlimited, and if current usage exceeds this limit
                if (maxUsage !== null && maxUsage !== -1 && currentUsed > maxUsage) {
                    this.lowerUsageFeatures.push({
                        'feature': feature.name,
                        'max_usage': maxUsage,
                        'current_usage': currentUsed
                    });
                }
            }
        }

        // Show warning if there are any features with exceeded usage limits in the selected offer
        if (this.lowerUsageFeatures.length > 0) {
            this.open(); // Open modal or alert to notify the user
            return; // Stop further processing
        } else {
            this.changeCheckoutOffer(
                recent_offer.id,
                recent_offer.monthly_price,
                recent_offer.annual_price
            );
        }
    } else {
        this.checkoutOffer(
            recent_offer.id,
            recent_offer.monthly_price,
            recent_offer.annual_price
        );
    }
}


  open() {

      Swal.fire({
        title: "Vous serez amené à désactiver vos comptes consultants/intervenants à la fin de votre abonnement en cours.",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085D6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'Annuler',
        confirmButtonText: 'Continue',
        customClass: {
          popup: 'swal2-popup-custom'  // On applique un style simple et direct
        }
      }).then((result) => {
        if (result.isConfirmed) {
          this.changeCheckoutOffer(
            this.selectedOffer.id,
            this.selectedOffer.monthly_price,
            this.selectedOffer.annual_price
          );
        }
      });
  }

  checkoutOffer(recent_offer_id: any, monthly_price: any, annual_price: any) {
    let data = {
      offer_id: recent_offer_id,
      company_id: this.company_id,
      billing_cycle: this.perMonth ? 'month' : 'year',
      price: this.perMonth ? monthly_price : annual_price,
    };
    this.stripeService.redirectToCheckout(data).subscribe(
      (response) => {
        console.log(response.data.url);
        window.open(response.data.url, '_blank'); // Ouvre dans un nouvel onglet
      },
      (error) => {
        console.error('There has been a problem with your operation', error);
      }
    );
  }

  changeCheckoutOffer(
    recent_offer_id: any,
    monthly_price: any,
    annual_price: any
  ) {
    this.loading = true; // Start loading

    let data = {
      recent_offer_id: recent_offer_id,
      company_id: this.company_id,
      billing_cycle: this.perMonth ? 'month' : 'year',
      price: this.perMonth ? monthly_price : annual_price,
    };

    this.stripeService.redirectToCheckoutChangeOffer(data).subscribe(
      (response) => {
        this.loading = false; // Stop loading when the response comes

        if (response && response.status === 200) {
          if (response.data && response.data.url) {
            window.open(response.data.url, '_blank'); // Open in a new tab
          } else {           
            if(response?.message?.includes('Upgrade scheduled successfully.')) {
              this.toastr.success('Mise à niveau planifiée avec succès.');
            } else if(response?.message?.includes('Downgrade scheduled successfully.')) {
              this.toastr.success('Rétrogradation planifiée avec succès.');
            } else{
              this.toastr.success('Changement d\'offre réussi.');
            }
            // Display success message

            // Wait 2 seconds before redirecting
            setTimeout(() => {
              window.location.href = '/subscription-success';
            }, 2000); // 2000ms = 2 seconds
          }
        } else {
          this.toastr.error('Une erreur s\'est produite lors du changement d\'offre.');
        }
      },
      (error) => {
        this.loading = false; // Stop loading in case of error

        if (error.error && error.error.message) {
          this.toastr.error(error.error.message);
        } else {
          this.toastr.error('Une erreur de serveur s\'est produite.');
        }
        console.error('There has been a problem with your fetch operation:', error);
      }
    );
  }


  // Method to check if a feature is active for an offer
  isFeatureActive(offer: any, featureId: number): boolean {
    return offer.features.some((feature: any) => feature.id === featureId);
  }

// Function to get the feature object in offer.features if it exists
getFeatureInOffer(offer: any, featureId: number): any | null {
  // Find the feature by its ID
  const feature = offer.features.find((feature: any) => feature.id === featureId);

  // Check if the feature exists and has metadata with max_usage
  if (feature && feature.pivot && feature.pivot.metadata) {
    // Add max_usage to the feature object for easier access
    return {
      ...feature,
      max_usage: feature.pivot.metadata.max_usage || null
    };
  }

  return null;
}

  // Method to get the max usage text if present
  getMaxUsageText(offre: { [x: string]: any; }, feature: { property: string | number; type: string; }): string {
    const prop = offre[feature.property];
    if (feature.type === 'number' && prop != null) {
      return ' : ' + prop;
    }
    return '';
  }

  getFormattedFeatureText(featureName: string, list: any[]): string {
    return this.lowerUsageFeatures.filter(f => f.feature === featureName)
      .map(f => `${f.feature} (${(f.current_usage - list.length)} / ${f.max_usage})`)
      .join('\n');
  }
  /* unsubscribe from api */
  ngOnDestroy() {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }
}
